// Generated by purs version 0.15.0
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Restaumatic_Locales from "../Restaumatic.Locales/index.js";
import * as Unscramble from "../Unscramble/index.js";
var Translated = function (x) {
    return x;
};
var Localized = function (x) {
    return x;
};
var unTranslated = function (v) {
    return v;
};
var udecodeTranslated = function (dictDecode) {
    return Unscramble.decodeMap(Restaumatic_Locales.ufromJSONKeyLocale)(Restaumatic_Locales.ordLocale)(dictDecode);
};
var showTranslated = function (dictShow) {
    return Data_Map_Internal.showMap(Restaumatic_Locales.showLocale)(dictShow);
};
var ordTranslated = function (dictOrd) {
    return Data_Map_Internal.ordMap(Restaumatic_Locales.ordLocale)(dictOrd);
};
var newtypeTranslated = {
    Coercible0: function () {
        return undefined;
    }
};
var singletonTranslated = function (locale) {
    return function (value) {
        return Data_Newtype.wrap()(Data_Map_Internal.singleton(locale)(value));
    };
};
var eqTranslated = function (dictEq) {
    return Data_Map_Internal.eqMap(Restaumatic_Locales.eqLocale)(dictEq);
};
var encodeTranslated = function (dictEncode) {
    return {
        encode: (function () {
            var mapToArray = Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
            var $19 = Foreign_Generic_Class.encode(Foreign_Generic_Class.objectEncode(dictEncode));
            var $20 = Foreign_Object.fromFoldable(Data_Foldable.foldableArray);
            var $21 = Data_Functor.map(Data_Functor.functorArray)(Data_Bifunctor.lmap(Data_Bifunctor.bifunctorTuple)(Restaumatic_Locales.toText));
            return function ($22) {
                return $19($20($21(mapToArray(unTranslated($22)))));
            };
        })()
    };
};
var emptyTranslated = /* #__PURE__ */ Data_Newtype.wrap()(Data_Map_Internal.empty);
var defaultLocale = /* #__PURE__ */ (function () {
    return Restaumatic_Locales.PL.value;
})();
var getLocalization = function (locale) {
    return function (v) {
        return Data_Maybe.fromMaybe("")(Control_Alt.alt(Data_Maybe.altMaybe)(Data_Map_Internal.lookup(Restaumatic_Locales.ordLocale)(locale)(v))(Data_Map_Internal.lookup(Restaumatic_Locales.ordLocale)(defaultLocale)(v)));
    };
};
var decodeTranslated = function (dictDecode) {
    return {
        decode: function (f) {
            var mapFromArray = Data_Map_Internal.fromFoldable(Restaumatic_Locales.ordLocale)(Data_Foldable.foldableArray);
            var decodeEntry = function (v) {
                return Control_Apply.apply(Control_Monad_Except_Trans.applyExceptT(Data_Identity.monadIdentity))(Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Data_Tuple.Tuple.create)(Foreign_Generic_Class.decode(Restaumatic_Locales.decodeLocale)(Foreign.unsafeToForeign(v.value0))))(Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(v.value1));
            };
            return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Foreign_Object.toUnfoldable(Data_Unfoldable.unfoldableArray))(Foreign_Generic_Class.decode(Foreign_Generic_Class.objectDecode(dictDecode))(f)))(function (v) {
                return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Data_Traversable.traverse(Data_Traversable.traversableArray)(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(decodeEntry)(v))(function (v1) {
                    return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Translated(mapFromArray(v1)));
                });
            });
        }
    };
};
export {
    Translated,
    Localized,
    getLocalization,
    emptyTranslated,
    singletonTranslated,
    newtypeTranslated,
    eqTranslated,
    ordTranslated,
    showTranslated,
    udecodeTranslated,
    decodeTranslated,
    encodeTranslated
};
export {
    CS,
    DE,
    EN,
    EN_GB,
    ES,
    HR,
    IT,
    NL,
    PL,
    PT_BR,
    RO,
    RU,
    SK
} from "../Restaumatic.Locales/index.js";
//# sourceMappingURL=index.js.map
